import { render, staticRenderFns } from "./PurchaseInfoRecordEdit.vue?vue&type=template&id=132d11ba&scoped=true&"
import script from "./PurchaseInfoRecordEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseInfoRecordEdit.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInfoRecordEdit.vue?vue&type=style&index=0&id=132d11ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d11ba",
  null
  
)

export default component.exports